import { DateTime } from 'luxon';
import { useObservableState } from 'observable-hooks';
import { useEffect, useState } from 'react';
import { debounceTime, distinctUntilChanged } from 'rxjs';

import {
  GeneralSetting,
  useGeneralSetting,
} from '../../util/use-general-setting';

function createInitialDate() {
  return DateTime.now().startOf('year').toJSDate();
}

export const useStatisticNavigation = () => {
  const [currentDate] = useState(createInitialDate);

  const startBusinessYearSetting = useGeneralSetting({
    name: GeneralSetting.startBusinessYear,
  });

  const [currentYear, setCurrentYear] = useObservableState(
    (input$) => input$.pipe(distinctUntilChanged(), debounceTime(200)),
    currentDate
  );
  const [maxYear, setMaxYear] = useState(currentDate);
  useEffect(() => {
    const businessYearStartMonth =
      startBusinessYearSetting?.data?.[0]?.value || 1;

    // We want to see current year https://work4all.atlassian.net/browse/WW-6438
    const year = currentDate.getFullYear();
    const date = DateTime.local(year, businessYearStartMonth, 1).toJSDate();

    setCurrentYear(date);
    setMaxYear(date);
  }, [currentDate, setCurrentYear, setMaxYear, startBusinessYearSetting]);

  return { currentYear, maxYear, setCurrentYear };
};
